import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import removed from '@mailobj-browser/front/js/tree/removed.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import { events } from '#utilities/js/lightboxes/lightbox.js'

const { open } = events
export const rtes = new WeakMap()

const onOpen = object(listener, {
  type: open,
  passive,
  task: (
    opener
  ) => {
    const form = closest('form', opener)
    const iframe = one('iframe', form)
    const rte = rtes.get(iframe)

    if (rte) {
      const r = one('[type="hidden"][name="random"]', rte)
      const t = one('[type="hidden"][name="time"]', rte)

      if (r) {
        r.value = Math.floor(Math.random() * 10000000000)
      }

      if (t) {
        const d = new Date()
        t.value = Math.floor(d.getTime() / 1000)
      }
    }
  }
})

export default button => {
  const rte = closest('[data-contract="rte.iframe"]', button)

  if (rte) {
    const iframe = one('iframe', rte)

    onOpen.listen(button)

    rtes.set(iframe, rte)

    queueMicrotask(async () => {
      await removed(rte)
      if (rtes.get(iframe) === rte) {
        rtes.delete(iframe)
      }
    })
  }
}